<template>
  <el-form
    ref="elForm"
    :model="formData"
    :rules="rules"
    size="middle"
    label-position="top"
    v-on:paste="handlePaste"
  >
    <div style="display: flex">
      <el-form-item label="产品型号" prop="model">
        <el-input v-model="formData.model" placeholder="请输入产品型号" clearable>
        </el-input>
      </el-form-item>

      <el-form-item label="产品状态" prop="status" style="margin-left: 20px">
        <el-select v-model="formData.status" placeholder="产品状态" clearable>
          <el-option v-for="item in status" :value="item" :key="item">{{
            item
          }}</el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="适用范围" prop="limit" style="margin-left: 20px">
        <el-select v-model="formData.limit" placeholder="适用范围" clearable>
          <el-option v-for="item in limit" :value="item" :key="item">{{
            item
          }}</el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="客户编号" prop="customerID" style="margin-left: 20px">
        <el-input v-model="formData.customerID" placeholder="(选填)" clearable>
        </el-input>
      </el-form-item>

      <el-form-item label="车款编号" prop="bikeID" style="margin-left: 20px">
        <el-input v-model="formData.bikeID" placeholder="(选填)" clearable> </el-input>
      </el-form-item>
    </div>

    <el-row >
      <el-col :span="3">
      <el-form-item label="认证" prop="certification" >
        <el-input v-model="formData.certification" placeholder="(选填)" clearable> </el-input>
      </el-form-item>
    </el-col>

    </el-row>


    <el-form-item label="产品图片" prop="specification"> </el-form-item>

    <div style="margin-left: 21px; margin-bottom: 20px; text-align: left">
      <a style="height: 30px" class="a-upload">
        <input @change="OnFileChange" type="file" />点击这里上传图片，或使用Ctrl+V粘贴图片
      </a>
      <img style="width: 200px; display: block; margin-top: 20px" :src="uploadImg" />

      <div style="color: red">*图片不得大于500k</div>
    </div>

    <el-form-item label="产品描述" prop="description">
      <editor style="height: 600px" v-model="formData.description" :init="init" />
    </el-form-item>
    <el-form-item label="产品备注(选填)" prop="remark">
      <el-input
        v-model="formData.remark"
        type="textarea"
        placeholder="请输入产品备注"
        :rows="5"
        clearable
        :style="{ width: '100%' }"
      >
      </el-input>
    </el-form-item>
    <!-- <el-form-item label="标准价格" prop="price">
      <el-input
        v-model="formData.price"
        placeholder="请输入标准价格"
        clearable
        :style="{ width: '100%' }"
      >
      </el-input>
    </el-form-item>
    <el-form-item label="成本价格" prop="cost">
      <el-input
        v-model="formData.cost"
        placeholder="请输入成本价格"
        clearable
        :style="{ width: '100%' }"
      ></el-input>
    </el-form-item> -->
    <el-form-item size="large">
      <el-button type="info" @click="previewShow = true">预览</el-button>
      <el-button type="primary" @click="submitForm">提交</el-button>
      <el-button @click="resetForm">返回</el-button>
    </el-form-item>
  </el-form>

  <el-dialog :width="1400" v-model="previewShow">
    <div class="card shadow">
      <div class="card-body">
        <div
          id="dataTable"
          class="table-responsive table mt-2"
          role="grid"
          aria-describedby="dataTable_info"
          style="overflow-y: hidden"
        >
          <table id="dataTable" class="table my-0">
            <thead>
              <tr>
                <th style="width: 63px">序号</th>
                <th><span>型号</span></th>
                <th style="width: 50px">图片</th>
                <th>状态</th>
                <!-- <th>规格</th> -->
                <th style="max-width: 500px">产品简介</th>
                <th style="max-width: 200px">备注</th>
                <!--                <th>标准报价</th>-->
                <!--                <th>成本价格</th>-->
                <th>客户编号</th>
                <th>车款编号</th>
              </tr>
            </thead>
            <tbody>
              <tr style="height: 1px">
                <td>1</td>
                <td>{{ formData.model }}</td>
                <td style="text-align: center">
                  <img
                    @click="imgViewClick(formData)"
                    :src="formData.picture"
                    style="height: 100px; cursor: pointer"
                  />
                </td>
                <td>{{ formData.status }}</td>
                <td>
                  <div style="max-width: 600px" v-html="formData.description" />
                </td>
                <td style="max-width: 300px; white-space: pre-wrap; text-align: left">
                  {{ formData.remark }}
                </td>

                <td style="height: inherit; padding: 0">
                  <div style="height: 100%; display: flex; flex-direction: column">
                    <div
                      style="
                        flex: 1;
                        display: table;
                        margin-bottom: -1px;
                        border-bottom: 1px solid #e3e6f0;
                      "
                      :key="strs"
                      v-for="strs in splitStr(formData.customerID)"
                    >
                      <div style="display: table-cell; vertical-align: middle">
                        {{ strs }}
                      </div>
                    </div>
                  </div>
                </td>
                <td style="height: inherit; padding: 0">
                  <div style="height: 100%; display: flex; flex-direction: column">
                    <div
                      style="
                        flex: 1;
                        display: table;
                        margin-bottom: -1px;
                        border-bottom: 1px solid #e3e6f0;
                      "
                      :key="strs"
                      v-for="strs in splitStr(formData.bikeID)"
                    >
                      <div style="display: table-cell; vertical-align: middle">
                        {{ strs }}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Swal from "sweetalert2";
import "../common/httphelper.js";
import { AddProduct, UpdateProduct } from "../common/httphelper.js";
import Editor from "@tinymce/tinymce-vue";
import getRole from "../common/role";
export default {
  components: { Editor },
  props: [],
  data() {
    return {
      previewShow: false,
      role: {},
      isUpdate: false,
      formData: {
        model: undefined,
        picture: undefined,
        bikeID: null,
        customerID: null,
        status: undefined,
        limit: undefined,
        specification: undefined,
        description: undefined,
        remark: undefined,
        // price: undefined,
        // cost: undefined,
        catlogid: undefined,
        certification:undefined,
      },
      rules: {
        model: [
          {
            required: true,
            message: "请输入产品型号",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "请输入产品状态",
            trigger: "blur",
          },
        ],
        limit: [
          {
            required: true,
            message: "请输入产品适用范围",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: false,
            message: "请输入产品备注",
            trigger: "blur",
          },
        ],
        // price: [
        //   {
        //     required: true,
        //     message: "请输入标准价格",
        //     trigger: "blur",
        //   },
        // ],
        // cost: [
        //   {
        //     required: true,
        //     message: "请输入成本价格",
        //     trigger: "blur",
        //   },
        // ],
      },
      uploadImg: "",
      catlogName: undefined,
      status: ["量产", "停产", "已确认", "样品"],
      limit: ["客户定制", "公版"],
      init: {
        language: "zh-Hans", //语言
        paste_as_text: true,
        paste_webkit_styles: "color font-size",
        branding: false,
        elementpath: false,
        toolbar:
          "undo redo | styleselect | fontsizeselect | forecolor | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link image | code",
        plugins: [
          "advlist autolink lists link charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help",
          "codesample",
        ],
        contextmenu: "bold copy paste",
        content_style: "p {margin: 0}",
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.formData.catlogid = this.$route.query.id;
    this.catlogName = this.$route.query.name;
    this.formData.price = Number(this.formData.price);
    this.formData.cost = Number(this.formData.cost);

    if (this.$route.query.item) {
      this.isUpdate = true;
      this.formData = JSON.parse(this.$route.query.item);

      this.uploadImg = this.formData.picture;
    }

    this.role = getRole();
  },
  methods: {
    submitForm() {
      this.$refs["elForm"].validate(async (valid) => {
        if (!valid) {
          window.scrollTo(0, 0);
          return;
        }

        if (!this.formData.picture) {
          await Swal.fire({
            icon: "error",
            title: "请上传图片",
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
        ///loading

        if (JSON.stringify(this.formData) === this.$route.query.item) {
          await Swal.fire({
            icon: "error",
            title: "内容无更新，无需提交",
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        Swal.fire({
          title: "上传中...",
          html: "请稍候...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        ///
        if (!this.isUpdate) {
          ////////////////////增加产品
          await AddProduct(this.formData).then(async (res) => {
            if (res.data.data) {
              await Swal.fire({
                icon: "success",
                title: "已提交审核",
                showConfirmButton: false,
                timer: 3000,
              });
              this.$router.push({
                name: "ProductList",
                query: { id: this.formData.catlogid, name: this.catlogName },
              });
              //this.$router.push('MyApprove');
            } else {
              await Swal.fire({
                icon: "error",
                title: res.data.message,
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });
          ///////////////////////////////////////
        } else {
          UpdateProduct(this.formData).then(async (res) => {
            if (res.data.data) {
              await Swal.fire({
                icon: "success",
                title: "已提交审核",
                showConfirmButton: false,
                timer: 3000,
              });
              this.$router.push({
                name: "ProductList",
                query: { id: this.formData.catlogId, name: this.catlogName },
              });
              // this.$router.push('MyApprove');
            } else {
              await Swal.fire({
                icon: "error",
                title: res.data.message,
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });

          ///////////////修改产品
        }
      });
    },
    resetForm() {
      this.$router.go(-1);
    },

    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;

      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        this.$message.error("粘贴内容非图片");
        return;
      }

      if (file.size > 500000) {
        Swal.fire({
          icon: "error",
          title: "图片不得大于500k",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }

      let reader = new FileReader();
      reader.readAsDataURL(file);
      let me = this;
      reader.onload = function (event) {
        me.uploadImg = event.target.result;
        me.formData.picture = event.target.result;
      };
    },
    splitStr(str) {
      if (!str) {
        return ["/"];
      } else {
        console.log(str);
        return str.split("/");
      }
    },
    OnFileChange(event) {
      let reader = new FileReader();

      if (!event.target.files[0]) {
        return;
      }

      if (event.target.files[0].size > 500000) {
        Swal.fire({
          icon: "error",
          title: "图片不得大于500k",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }

      reader.readAsDataURL(event.target.files[0]);
      let me = this;
      reader.onload = function (event) {
        me.uploadImg = event.target.result;
        me.formData.picture = event.target.result;
      };
    },
  },
};
</script>

<style scoped>
.el-form-item__content {
  z-index: 0 !important;
  text-align: left;
}

/*a  upload */
.a-upload {
  padding: 4px 10px;
  height: 20px;
  line-height: 20px;
  position: relative;
  cursor: pointer;
  color: #888;
  background: #fafafa;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  display: inline-block;
  *display: inline;
  *zoom: 1;
  text-decoration: none;
}

.a-upload input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
}

.a-upload:hover {
  color: #444;
  background: #eee;
  border-color: #ccc;
  text-decoration: none;
}

tr th td {
  text-align: center;
  vertical-align: middle !important;
  border: 1px solid #e3e6f0 !important;
}
</style>
